import request from "../../utils/request";
import { Result } from "../../models/general";

// AI Settings types
export interface AISettingsView {
  companyId: number;
  companyName: string;
  aiFeaturesEnabled: boolean;
  hasCustomAIKey: boolean;
  azureOpenAIEndpoint: string | null;
  azureOpenAIChatDeployment: string | null;
}

export interface AISettingsInput {
  aiFeaturesEnabled?: boolean | null;
  azureOpenAIEndpoint?: string | null;
  azureOpenAIApiKey?: string | null;
  azureOpenAIChatDeployment?: string | null;
  clearAIKey?: boolean;
}

/**
 * Get AI settings for all companies (Operator only)
 */
export async function getCompaniesAISettings() {
  const response = await request.get<Result<AISettingsView[]>>("AISettings/Companies");
  return response.data;
}

/**
 * Get AI settings for a specific company (Operator only)
 */
export async function getCompanyAISettings(companyId: number) {
  const response = await request.get<Result<AISettingsView>>(`AISettings/${companyId}`);
  return response.data;
}

/**
 * Update AI settings for a specific company (Operator only)
 */
export async function updateCompanyAISettings(companyId: number, input: AISettingsInput) {
  const response = await request.put<Result<AISettingsView>>(`AISettings/${companyId}`, input);
  return response.data;
}
